import { render, staticRenderFns } from "./WordBasics.vue?vue&type=template&id=120d78a6&scoped=true"
import script from "./WordBasics.vue?vue&type=script&lang=js"
export * from "./WordBasics.vue?vue&type=script&lang=js"
import style0 from "./WordBasics.vue?vue&type=style&index=0&id=120d78a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d78a6",
  null
  
)

export default component.exports